import React from "react";
import PropTypes from "prop-types";

function Button({
  label,
  type = "submit",
  status = "theme",
  disabled = false,
  isdisabled = false,
  onClick,
  icon = null,
  className,
  name,
  imgsrc = null,
  title,
}) {
  return (
    <button
      type={type}
      className={`btn button-${status} btn-lg w-inherit cursor-pointer ${className}`}
      disabled={disabled || isdisabled}
      onClick={onClick}
      name={name}
      title={title || label.toUpperCase()}
    >
      {imgsrc && <img src={imgsrc} name={name} alt="" className="btn-imgsrc" onClick={onClick} />}
      {icon != null && (
        <span className="me-2 font-size-16">
          <i className={"fa fa-" + icon}></i>
        </span>
      )}
      {label && label?.toUpperCase() + " "}

      {type === "submit" && disabled && (
        <div className="spinner-border spinner-border-sm" role="status"></div>
      )}
    </button>
  );
}

Button.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  status: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  icon: PropTypes.string,
};

export default Button;
